import { render } from "./SurveyQuestionText.vue?vue&type=template&id=68739733"
import script from "./SurveyQuestionText.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionText.vue?vue&type=script&lang=js"

import "./SurveyQuestionText.vue?vue&type=style&index=0&id=68739733&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__